import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

const meetingTemplateFormSchema = z.object({
  meeting_name: z.string(),
  meeting_category: z.string(),
  meeting_type: z.string(),
  agenda: z.array(
    z.object({
      itemNo: z.string().min(1, 'Item Number is required'),
      topic: z.string().min(1, 'Topic is required'),
      discussion_points: z.array(
        z.object({
          name: z.string().min(1, 'Discussion Point is required'),
        }),
      ),
    }),
  ),
});

export type MeetingTemplateForm = z.infer<typeof meetingTemplateFormSchema>;

export const meetingTemplateFormDefaultValues: MeetingTemplateForm = {
  meeting_name: '',
  meeting_category: '',
  meeting_type: '',
  agenda: [
    {
      itemNo: '1.',
      topic: '',
      discussion_points: [{ name: '' }],
    },
  ],
};

export const useMeetingTemplateForm = () => {
  const form = useForm({
    resolver: zodResolver(meetingTemplateFormSchema),
    defaultValues: meetingTemplateFormDefaultValues,
  });
  return form;
};
